import React from 'react';
import Dog from './Dog.jpeg';


const highlights = () => {
  return (
    <div>
         <img style={{width:'25%',height:'25%'}} src={Dog} alt="others"/>
    </div>
  );
};

export default highlights;